import { QueryClient } from "@tanstack/react-query";

import { isAxiosError } from "../utils";

export enum QueryCacheKey {
  DATA_IMPORTS = "DATA_IMPORTS",
  DATA_IMPORT = "DATA_IMPORT",
  WRITEBACK = "WRITEBACK",
  DATA_IMPORT_RUNS = "DATA_IMPORT_RUNS",
  DATA_SOURCES = "DATA_SOURCES",
  DATA_SOURCE = "DATA_SOURCE",
  CLOUD_TABLES = "CLOUD_TABLES",
  CLOUD_TABLE = "CLOUD_TABLE",
  CLOUD_TABLE_PREVIEW_DATA = "CLOUD_TABLE_PREVIEW_DATA",
  CLOUD_TABLE_DATA = "CLOUD_TABLE_DATA",
  GOOGLE_DRIVE_AUTH_TOKEN = "GOOGLE_DRIVE_AUTH_TOKEN",
  DOMAIN_USERS = "DOMAIN_USERS",
  DOMAIN_INVITATIONS = "DOMAIN_INVITATIONS",
  BILLING_DETAILS = "BILLING_DETAILS",
  WEB_DASHBOARD_OFFER = "WEB_DASHBOARD_OFFER",
  AI_USAGE_ALLOWANCE = "AI_USAGE_ALLOWANCE",
  GOOGLE_API_CURRENT_USER = "GOOGLE_API_CURRENT_USER",
  GOOGLE_API_SPREADSHEET_DATA = "GOOGLE_API_SPREADSHEET_DATA",
  ADMIN_EXT_SETTINGS = "ADMIN_EXT_SETTINGS",
  SNOWFLAKE_APP_INFO = "SNOWFLAKE_APP_INFO",
  CUSTOM_OAUTH_APP_INFO = "CUSTOM_OAUTH_APP_INFO",
  LOOKER_APP_INFO = "LOOKER_APP_INFO",
  TABLEAU_APP_INFO = "TABLEAU_APP_INFO",
  DATABRICKS_APP_INFO = "DATABRICKS_APP_INFO",
  ARROW_FLIGHT_SQL_APP_INFO = "ARROW_FLIGHT_SQL_APP_INFO",
  NETSUITE_APP_INFO = "NETSUITE_APP_INFO",
  WRITEBACKS_SCHEMA = "WRITEBACKS_SCHEMA",
  DATA_IMPORT_RUN_BY_ID = "DATA_IMPORT_RUN_BY_ID",
  USER_SSO_INFO = "USER_SSO_INFO",
  CLIENT_FLAGS = "CLIENT_FLAGS",
  ALERTS = "ALERTS",
  ALERT_RUN_HISTORY = "ALERT_RUN_HISTORY",
  VERIFY_OAUTH_TOKEN = "VERIFY_OAUTH_TOKEN",
  LOOKER_REQUEST_INFO_BY_UUID = "LOOKER_REQUEST_INFO_BY_UUID",
  FILTER_OPTIONS = "FILTER_OPTIONS",
  DASHBOARD_SPREADSHEETS = "DASHBOARD_SPREADSHEETS",
  ADMIN_EXT_ALERTS = "ADMIN_EXT_ALERTS",
  ADMIN_EXT_USERS = "ADMIN_EXT_USERS",
  ADMIN_EXT_DATA_IMPORTS = "ADMIN_EXT_DATA_IMPORTS",
  ADMIN_EXT_DATA_IMPORT_RUNS = "ADMIN_EXT_DATA_IMPORT_RUNS",
  ADMIN_EXT_DATA_IMPORT_RUN = "ADMIN_EXT_DATA_IMPORT_RUN",
  ADMIN_EXT_DATA_WRITEBACKS = "ADMIN_EXT_DATA_WRITEBACKS",
  ADMIN_EXT_WRITEBACK_RUNS = "ADMIN_EXT_WRITEBACK_RUNS",
  ADMIN_EXT_DATA_SOURCES = "ADMIN_EXT_DATA_SOURCES",
  ADMIN_EXT_WEB_DASHBOARDS = "ADMIN_EXT_WEB_DASHBOARDS",
  ADMIN_EXT_DATA_SOURCE = "ADMIN_EXT_DATA_SOURCE",
  ADMIN_EXT_DATA_SOURCE_DETAILS = "ADMIN_EXT_DATA_SOURCE_DETAILS",
  OAUTH_ATTEMPT_TEST = "OAUTH_ATTEMPT_TEST",
  OAUTH_ATTEMPT = "OAUTH_ATTEMPT",
  SLACK_AUTH_STATUS = "SLACK_AUTH_STATUS",
  MS_TEAMS_AUTH_STATUS = "MS_TEAMS_AUTH_STATUS",
  MS_TEAMS_TEAMS_AND_CHANNELS = "MS_TEAMS_TEAMS_AND_CHANNELS",
  SLACK_CHANNELS_AND_USERS = "SLACK_CHANNELS_AND_USERS",
  WEB_DASHBOARDS = "WEB_DASHBOARDS",
  WEB_DASHBOARD_PLAN_USAGE = "WEB_DASHBOARD_PLAN_USAGE",
  WEB_DASHBOARD_CUSTOM_THEMES = "WEB_DASHBOARD_CUSTOM_THEMES",
  WEB_DASHBOARD = "WEB_DASHBOARD",
  USER_MEMORY = "USER_MEMORY",
  WEB_DASHBOARD_PERMISSIONS = "WEB_DASHBOARD_PERMISSIONS",
  WEB_DASHBOARD_REFRESH_RUN = "WEB_DASHBOARD_REFRESH_RUN",
  WEB_DASHBOARD_LATEST_RUN = "WEB_DASHBOARD_LATEST_RUN",
  AGENT_THREAD = "AGENT_THREAD",
  AGENT_THREAD_RUN = "AGENT_THREAD_RUN",
  WEB_DASHBOARD_SHARES = "WEB_DASHBOARD_SHARES",
  WEB_DASHBOARD_SUBSCRIPTIONS = "WEB_DASHBOARD_SUBSCRIPTIONS",
  WEB_DASHBOARD_SUBSCRIPTION_RUNS = "WEB_DASHBOARD_SUBSCRIPTION_RUNS",
  THREAD_ANALYSES = "THREAD_ANALYSES",
  THREAD_ANALYSIS_RESULTS = "THREAD_ANALYSIS_RESULTS",
  AGENT_THREAD_MESSAGES = "AGENT_THREAD_MESSAGES",
}

const MAX_RETRIES = 1;

const HTTP_STATUS_TO_NOT_RETRY = [400, 401, 403, 404, 409];

export const initQueryClient = () => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (failureCount > MAX_RETRIES) {
            return false;
          }

          if (
            isAxiosError(error) &&
            HTTP_STATUS_TO_NOT_RETRY.includes(error.response?.status ?? 0)
          ) {
            return false;
          }

          return true;
        },
        networkMode: "always",
        staleTime: 1000 * 60 * 5,
      },
      mutations: {
        networkMode: "always",
      },
    },
  });
};
